module.exports = __webpack_public_path__ + "img/site-fernando-santos.a95736d2.jpg";